import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PermissionGate from './PermissionGate';

/**
 * ProtectedRoute - Combines authentication and permission checks
 * 
 * Usage:
 * <Route path="/vendors" element={
 *   <ProtectedRoute permission="view_vendors">
 *     <VendorsNew />
 *   </ProtectedRoute>
 * } />
 */
const ProtectedRoute = ({ children, permission = 'all' }) => {
  const { user, loading } = useAuth();

  // Show loading state
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg text-gray-600">Loading...</div>
      </div>
    );
  }

  // Check authentication first
  if (!user) {
    return <Navigate to="/login" />;
  }

  // Then check permissions
  return (
    <PermissionGate permission={permission}>
      {children}
    </PermissionGate>
  );
};

export default ProtectedRoute;
